import { render, staticRenderFns } from "./OptionCardModal.vue?vue&type=template&id=71984e7d&scoped=true"
import script from "./OptionCardModal.vue?vue&type=script&lang=js"
export * from "./OptionCardModal.vue?vue&type=script&lang=js"
import style0 from "./OptionCardModal.vue?vue&type=style&index=0&id=71984e7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71984e7d",
  null
  
)

export default component.exports